import { Box, Button, Divider, Menu, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { font } from "../../styles/font";
import { DateCalendar } from "@mui/x-date-pickers";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from "dayjs";
import { CalendarMonthOutlined } from "@mui/icons-material";


export default function CalenderRangeButton({ selectedDate, setSelectedDate }) {

    const theme = useTheme();

    const [currentSelectedDate, setCurrentSelectedDate] = useState({
        startDate: dayjs(),
        endDate: dayjs().add(6, 'day')
    });
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs().add(6, 'day'));


    const [calendarAnchorEl, setCalendarAnchorEl] = useState(null);


    const handleToggleCalendarMenu = (event) => {
        if (calendarAnchorEl) {
            setCalendarAnchorEl(null);
        } else {
            setCalendarAnchorEl(event.currentTarget);
        }
    }


    const handleChangeStartDate = (date) => {
        setStartDate(date);
        setEndDate(dayjs(date).add(6, 'day')) // Set end date to 6 days after start date;



        // const startOfWeek = dayjs(date).startOf('week');
        // const endOfWeek = dayjs(date).endOf('week');
        // setStartDate(startOfWeek);
        // setEndDate(endOfWeek);
    }

    const handleChangeEndDate = (newValue) => {
        setEndDate(newValue);
    }


    const handleApplyDate = () => {
        setSelectedDate({
            startDate: startDate,
            endDate: endDate
        });
        setCalendarAnchorEl(null);
    };


    useEffect(() => {

        if (selectedDate) {
            setStartDate(selectedDate?.startDate);
            setEndDate(selectedDate?.endDate);


            setCurrentSelectedDate({
                startDate: selectedDate?.startDate,
                endDate: selectedDate?.endDate
            })
        }
    }, [selectedDate, setSelectedDate]);

    const renderDay = (date) => {
        if (date.isSame(startDate, 'day') || date.isSame(endDate, 'day')) {
            return (
                <Box sx={{ backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }}>
                    {date.date()}
                </Box>
            );
        } else if (date.isAfter(startDate, 'day') && date.isBefore(endDate, 'day')) {
            return (
                <Box sx={{ backgroundColor: theme.palette.background.default, color: theme.palette.text.primary }}>
                    {date.date()}
                </Box>
            );
        } else {
            return date.date();
        }
    };

    return (
        <Box>
            <Button variant="outlined" onClick={handleToggleCalendarMenu} sx={{ background: calendarAnchorEl && theme.palette.highlight.main }} >{dayjs(currentSelectedDate?.startDate)?.format("DD-MM-YYYY")} - {dayjs(currentSelectedDate?.endDate)?.format("DD-MM-YYYY")} <CalendarMonthOutlined sx={{ ml: 1 }} /> </Button>


            <Menu
                anchorEl={calendarAnchorEl}
                open={Boolean(calendarAnchorEl)}
                onClose={handleToggleCalendarMenu}
            >
                <Box className="flex flex-col ">
                    {/* header */}
                    <Box className="flex items-center justify-center gap-4 px-4 py-2">
                        <Typography fontSize={font.size.fs_4} color="textPrimary">Select Week Start Date</Typography>
                    </Box>

                    {/* main container */}
                    <Box className="flex-1 flex items-center gap-0 px-4 py-0  ">
                        {/* <CalendarContainer heading={"Start "}  > */}
                        <DateCalendar value={startDate} autoFocus onChange={handleChangeStartDate} />
                        {/* </CalendarContainer> */}

                        <Divider orientation="vertical" flexItem />

                        {/* <CalendarContainer heading={"End "} >
                            <DateCalendar value={endDate} onChange={handleChangeEndDate} />
                        </CalendarContainer> */}
                    </Box>

                    {/* footer */}
                    <Box className="flex items-center justify-end gap-4 px-4 py-2">
                        <Button variant="outlined" onClick={handleToggleCalendarMenu}  >Cancel</Button>
                        <Button variant="contained" color="secondary" sx={{ color: theme.palette.secondary.contrastText }} onClick={handleApplyDate}>Apply</Button>
                    </Box>
                </Box>
            </Menu>
        </Box>
    )
}


function CalendarContainer({ heading, children }) {
    const theme = useTheme();

    return (
        <Box className="flex flex-col gap-0 px-0 py-0 " borderRadius={theme.shape.borderRadius} bgcolor={theme.palette.background.custom} >
            <Box className="flex items-center justify-center gap-0 px-2 py-2 ">
                <Typography fontSize={font.size.fs_4} color="textPrimary">{heading}</Typography>
            </Box>
            <Box className="flex-1 flex flex-col gap-0 px-0 py-0 ">
                {children}
            </Box>
        </Box>
    )
}